import React from 'react';

import styles from './troy.module.scss';

import { Grid } from '../../components/common';
import { DemandTable, Timeline } from '../../components/home/index.troy';
import {
  PostBox,
  NotificationList,
} from '../../components/post-box/index.troy';

import {
  getCustomers,
  getDecisions,
  setFileModalOpened,
  uploadFile,
} from '../../actions';
import { connectTo } from '../../utils';

import {
  LIABILITY_INFO,
  POSTBOX,
  NOTIFICATIONS,
  LIABILITY_TABLE,
} from '../../constants/customerDetail';

import { getUrlParams } from '../../utils/httpUtil';

class CustomerDetail extends React.Component {
  constructor(props) {
    super(props);
    const { method } = getUrlParams();
    this.state = {
      urlParam: method,
    };
  }

  componentDidMount() {
    const { getDecisions, getCustomers, isAuthenticated } = this.props;
    if (isAuthenticated) {
      getDecisions();
      getCustomers();
    }
  }

  render() {
    const {
      demandTableHide,
      demandTableBlur,
      liabilityItems,
      liabilityStatus,
      balance,
      currency,
      liabilityStatementList,
      timelineHide,
      timelineBlur,
      timeline,
      token,
      notifications,
      groupCounts,
      searchDecision,
      fileUploadHidden,
      uploadFile,
      isFileLoading,
      isFileModalOpened,
      setFileModalOpened,
      fileUploadBlur,
      notificationsListBlur,
      internal,
    } = this.props;
    const { urlParam } = this.state;

    return (
      <div className={styles['customer-detail__wrapper']}>
        <div className={styles[`customer-detail__content_${urlParam}`]}>
          {urlParam === LIABILITY_INFO
            ? (liabilityItems && timeline && liabilityStatementList && (
                <div
                  className={
                    styles['customer-detail__liability-container-wrapper']
                  }
                >
                  <Grid
                    container
                    spacing={2}
                    className={styles['customer-detail__liability-container']}
                    item
                    justify="space-between"
                  >
                    {!demandTableHide && (
                      <Grid
                        md={4}
                        sm={5}
                        className={styles['customer-detail__demand-table']}
                        item
                      >
                        <DemandTable
                          blur={demandTableBlur}
                          items={liabilityItems}
                          balance={balance}
                          currency={currency}
                          extended={liabilityStatementList}
                          token={token}
                        />
                      </Grid>
                    )}
                    {!timelineHide && (
                      <Grid
                        md={8}
                        sm={7}
                        className={styles['customer-detail__timeline']}
                        item
                      >
                        <Timeline
                          blur={timelineBlur}
                          items={timeline}
                          liabilityStatus={liabilityStatus}
                          isClientPortal
                        />
                      </Grid>
                    )}
                  </Grid>
                </div>
              )) ||
              null
            : urlParam === LIABILITY_TABLE
            ? (liabilityItems && liabilityStatementList && (
                <div
                  className={
                    styles['customer-detail__liability-container-wrapper']
                  }
                >
                  {!demandTableHide && (
                    <div className={styles['customer-detail__demand-table']}>
                      <DemandTable
                        blur={demandTableBlur}
                        items={liabilityItems}
                        balance={balance}
                        currency={currency}
                        extended={liabilityStatementList}
                        token={token}
                      />
                    </div>
                  )}
                </div>
              )) ||
              null
            : null}
          {urlParam === POSTBOX || urlParam === NOTIFICATIONS ? (
            <PostBox
              {...{
                token,
                notifications,
                groupCounts,
                searchDecision,
                fileUploadHidden,
                fileUploadBlur,
                notificationsListBlur,
                uploadFile,
                isFileLoading,
                isFileModalOpened,
                setFileModalOpened,
              }}
              constantFilter={urlParam === NOTIFICATIONS}
              filterButtonClassName={
                urlParam === NOTIFICATIONS
                  ? styles['customer-detail__postbox-filter_notifications']
                  : null
              }
              internal={internal}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({
    auth: { token, internal },
    notifications: { list: notifications, groupCounts },
    decisions: { 'troy.feature.ui.postbox.textsearch': searchDecision },
    liability: { liabilityItems, timeline, liabilityStatus },
    payment: {
      paymentUserInfo: { totalBalance, dueCurrency },
    },
    ui: {
      home: {
        liabilityStatementList,
        blur: { demandTable: demandTableBlur, timeline: timelineBlur },
        hide: { timeline: timelineHide, demandTable: demandTableHide },
      },
      postBox: {
        blur: {
          fileUpload: fileUploadBlur,
          notificationsList: notificationsListBlur,
        },
      },
    },
  }) => ({
    token,
    internal,
    notifications,
    groupCounts,
    searchDecision,
    liabilityItems,
    liabilityStatus,
    timeline,
    demandTableBlur,
    timelineBlur,
    timelineHide,
    demandTableHide,
    balance: totalBalance,
    currency: dueCurrency,
    liabilityStatementList,
    fileUploadHidden: true,
    fileUploadBlur,
    notificationsListBlur,
  }),
  { getDecisions, getCustomers, uploadFile, setFileModalOpened },
  CustomerDetail
);
